import React, {useCallback, useEffect, useMemo, useState} from 'react'
import {useHistory} from 'react-router-dom'
import {useQuery} from 'react-query'
import {getLeadsList} from '../api'
import {useAppDispatch} from '../Contexts/AppContext'
import ListTable from '../components/ListTable/ListTable'
import LeadsListActions from './LeadsListActions'
import {formatBlackListRow} from '../helpers'
import {toServerDatetimeFormat} from '../Utils/dates'
import LeadStatus from '../components/LeadStatus'
import {storageKeys} from '../config'
import {useTranslation} from "react-i18next";

const LeadsList = () => {
    const { t } = useTranslation();
    const leadValue = formatBlackListRow
    const [leads, setLeads] = useState([])
    const [leadsAttributes, setLeadsAttributes] = useState([])
    const [selectedRows, setSelectedRows] = useState([])
    const [pagination, setPagination] = useState(null)
    const [search, setSearch] = useState()
    const [sorting, setSorting] = useState([])
    const [page, setPage] = useState(1)
    const [limit, setLimit] = useState(50)
    const {setBreadcrumbs, setSection, setContextMenu} = useAppDispatch()
    const history = useHistory()

    const tableColumns = useMemo(() => {
        const attributes = leadsAttributes.map(attr => {
            return {
                Header: attr.name,
                accessor: `${attr.id}`,
                Cell: leadValue
            }
        })
        return [
            // {
            //     Header: 'ID',
            //     accessor: 'id',
            //     Cell: leadValue
            // },
            {
                Header: t('Leads List.Updated Date'),
                accessor: 'updated_at',
                Cell: ({value, row}) => {
                    return leadValue({value: toServerDatetimeFormat(value), row})
                }
            },
            ...attributes,
            {
                Header: t('Leads List.Duplicates'),
                accessor: 'duplicates',
                Cell: leadValue
            },
            {
                Header: t('Leads List.Status'),
                accessor: 'status',
                className: 'col-sticky text-right',
                Cell: ({value}) => <LeadStatus status={value} />
            }
        ]
    }, [leadsAttributes, leadValue, t])
    const tableValues = useMemo(() => {
        return leads.map(item => {
            const leadValues = item.lead_values
            const newItem = {...item}
            leadValues.forEach(value => {
                const attrId = value && value.attribute && value.attribute.id
                if (attrId)
                    newItem[attrId] = newItem[attrId]
                        ? `${newItem[attrId]}; ${value.value}`
                        : value.value
            })
            delete newItem['lead_values']
            return newItem
        })
    }, [leads])

    const tableRecordsInfo = useMemo(() => {
        const info = []
        if (pagination) {
            if (pagination.total)
                info.push({count: pagination.total, label: t('Sources.Leads')})
            if (pagination.total_blacklisted)
                info.push({count: pagination.total_blacklisted, label: t('Sources.Blacklisted')})
        }
        return info
    }, [pagination])

    const {isSuccess, data, isLoading, isFetching} = useQuery(
        ['leadsList', page, limit, search, sorting],
        () => getLeadsList(page, limit, search, sorting),
        {keepPreviousData: true}
    )

    useEffect(() => {
        setBreadcrumbs([{label: 'Leads'}])
        setSection('leads')
    }, [setBreadcrumbs, setSection, setContextMenu])

    useEffect(() => {
        if (isSuccess) {
            setLeads(data.data)
            setPagination(data.meta)

            if (data.attributes) {
                setLeadsAttributes(data.attributes)
            }
        }
    }, [isSuccess, data])

    const handleItemClick = item => {
        history.push(`/leads/${item?.id}`)
    }

    const handleLimitChange = useCallback((l) => {
        setPage(1)
        setLimit(l)
    }, [setPage, setLimit])

    const handleSearchChange = useCallback((str) => {
        setPage(1)
        setSearch(str)
    }, [setPage, setSearch])

    return (
        <div className="pageHolder">
            <ListTable
                columns={tableColumns}
                data={tableValues}
                loading={isLoading}
                fetching={isFetching}
                isSelectionColumn={true}
                onSelectedRows={setSelectedRows}
                onRowClick={handleItemClick}
                onSort={setSorting}
                emptyDataText={t('Leads List.No Leads Found')}
                pagination={pagination}
                pageLimit={limit}
                onPageChange={setPage}
                onLimitChange={handleLimitChange}
                onSearch={handleSearchChange}
                recordsInfo={tableRecordsInfo}
                hiddenColumnsStorageKey={storageKeys.leadsHiddenColumnsInLeads}
                selectedRowIds={{'d647aebc-963b-40e4-9fd2-fe986efe1e3e': true}}
                showTabs={true}
                tabsValue={0}
            />
            <LeadsListActions
                selectedRows={selectedRows}
            />
        </div>
    )
}

export default LeadsList
